var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-input-code" }, [
    _c("div", { staticClass: "page-title" }, [_vm._v("请输入机身上的8位编码")]),
    _c(
      "div",
      { staticClass: "code", on: { click: _vm.tapCode } },
      [
        _c("input", {
          ref: "codeInput",
          attrs: { type: "tel", maxlength: "8" },
          on: { input: _vm.watchInput }
        }),
        _vm._l(8, function(_, idx) {
          return _c("div", { key: idx, staticClass: "code-item" }, [
            _vm._v(_vm._s(_vm.codeList[idx] || ""))
          ])
        })
      ],
      2
    ),
    _c("div", { staticClass: "tips" }, [
      _c("div", { staticClass: "image-title" }, [
        _vm._v("编码在机身二维码的下方")
      ]),
      _c("img", {
        staticClass: "image",
        attrs: { src: _vm.ossPondHost + "img/device_code.png" }
      })
    ]),
    _c(
      "div",
      {
        class: ["page-bottom", { active: _vm.codeList.length == 8 }],
        on: { click: _vm.onclickNextBtn }
      },
      [_vm._v("确 认")]
    ),
    _c(
      "div",
      { staticClass: "page-cancel", on: { click: _vm.onclickCancelManual } },
      [_vm._v("返回扫码")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }